import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayAndDistanceOfferLookupComponent } from './pay-and-distance-offer-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PayAndDistanceOfferLookupComponent],
  exports: [PayAndDistanceOfferLookupComponent],
  providers: []
})
export class PayAndDistanceOfferLookupModule { }
